module.exports = __webpack_public_path__ + "img/geschmiedetestreppengelaender.e5aa8797.webp";